// extracted by mini-css-extract-plugin
export default {"container":"styles_container__q0kJs","listingDetail":"styles_listingDetail__EZmgw","back":"styles_back__bhxXe","loading":"styles_loading__rjuvo"};